import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import React from "react";
import { Row, Col } from "react-bootstrap";
var StocksOfs = function (props) {
    var device = DeviceContext();
    return (React.createElement(Row, { className: "mx-0 searchblock-generic-block ".concat(!props.edit && "hand_cursor"), onClick: function () {
            !props.edit && props.onSelected && props.onSelected();
        } },
        React.createElement(Col, { lg: 12, className: "px-0 ".concat((device === null || device === void 0 ? void 0 : device.isDesktop)
                ? "d-space-between"
                : "dflex-start justify-content-between") },
            React.createElement("div", null,
                React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 d-flex lh-140" }, props.stockName),
                React.createElement("div", { className: "lh-140  ".concat((device === null || device === void 0 ? void 0 : device.isDesktop) ? "d-flex" : "d-block mgt-5") },
                    React.createElement("div", { className: "DMSansNormal_12_400 txt_secondary-gray" },
                        "Date Range",
                        React.createElement("span", { className: "txt_primaryGrey mgl-5" },
                            props.startDate,
                            " to ",
                            props.endDate)),
                    React.createElement("div", { className: "DMSansNormal_12_400 txt_secondary-gray ".concat((device === null || device === void 0 ? void 0 : device.isDesktop)
                            ? "imCircle  small-imcircle aligncenteritem"
                            : "d-flex") },
                        "Floor Price",
                        React.createElement("span", { className: "txt_primaryGrey mgl-5" },
                            "Rs.",
                            props.price)))),
            React.createElement("div", { className: "d-center-end" }, (props === null || props === void 0 ? void 0 : props.edit) ? (props.editAction) : (React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "small-edbutton-search pb-10-rem pt-10-rem px-29-rem", onClick: function () { return props.onApply(); } }))))));
};
export default StocksOfs;
